"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvolvedObject = /** @class */ (function () {
    function InvolvedObject() {
    }
    return InvolvedObject;
}());
exports.default = InvolvedObject;
//# sourceMappingURL=InvolvedObject.js.map